import { CSSObject, Theme } from '@emotion/react';

export const SIDE_NAV_DRAWER_WIDTH_EXPANDED = '256px';

export const SIDE_NAV_DRAWER_WIDTH_COLLAPSED = '72px';

export const drawerWidth = SIDE_NAV_DRAWER_WIDTH_EXPANDED;

export const SIDE_NAV_EASING = 'cubic-bezier(0.5, 0, 0.5, 1)';

export const SIDE_NAV_EXPAND_DURATION_MS = 400;

export const SIDE_NAV_CONTENT_FADE_DELAY_MS = 200;

export const SIDE_NAV_CONTENT_FADE_DURATION_MS = 200;

const REDUCED_MOTION_QUERY = '@media (prefers-reduced-motion: reduce)';

export const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  borderRight: 'none',
  zIndex: theme.zIndex.drawer,
  transition: theme.transitions.create('width', {
    easing: SIDE_NAV_EASING,
    duration: SIDE_NAV_EXPAND_DURATION_MS,
  }),
  overflowX: 'hidden',
  [REDUCED_MOTION_QUERY]: {
    transition: 'none',
  },
});

export const closedMixin = (theme: Theme): CSSObject => ({
  zIndex: theme.zIndex.drawer,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  borderRight: 'none',
  overflowX: 'hidden',
  [REDUCED_MOTION_QUERY]: {
    transition: 'none',
  },
  width: SIDE_NAV_DRAWER_WIDTH_COLLAPSED,
  [theme.breakpoints.up('sm')]: {
    width: SIDE_NAV_DRAWER_WIDTH_COLLAPSED,
  },
});
